import { Box, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC } from 'react';
import { IconProps } from '../../../icons/templates/icon';
import {
  CalendarShareArrowIcon,
  CoinGrowthIcon,
  DocumentCheckmarkIcon,
  MobileCheckmarkCircleIcon,
  ChristmasGiftIcon,
  ReceptionBellIcon,
  CashBanknoteCoinsIcon,
  WalletPlusIcon
} from '../../../icons';

const bonusIconMap: Record<string, FC<IconProps>> = {
  special_occasion: ReceptionBellIcon,
  non_cash_gift: CashBanknoteCoinsIcon,
  non_cash_benefit: ChristmasGiftIcon,
  fully_taxed: DocumentCheckmarkIcon,
  relief_premium_2026: WalletPlusIcon,
  app_voucher: MobileCheckmarkCircleIcon,
  external: CalendarShareArrowIcon,
  salary: CoinGrowthIcon
};

const getBonusIcon = (icon: string, size: number, color: string) => {
  const Component = icon in bonusIconMap ? bonusIconMap[icon] : undefined;
  if (Component) return <Component height={size} width={size} color={color} />;
};

interface Props {
  icon: string;
  sx?: SxProps<Theme>;
  size?: number;
  color?: string;
}

export const BonusIcon: FC<Props> = ({ icon, size, color = 'primary.main', sx }) => {
  size = size ?? 48;
  return (
    <Box sx={{ height: size, width: size, ...sx }}>
      {getBonusIcon(icon.toLowerCase(), size, color)}
    </Box>
  );
};
